import { useEffect, useState } from "react";

export const useIntersectionObserver = (
  elementRef: React.RefObject<HTMLElement | null>,
  options: IntersectionObserverInit
): boolean => {
  const [isIntersecting, setIsIntersecting] = useState(true);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        setIsIntersecting(entry.isIntersecting);
      });
    }, options);

    if (elementRef?.current) {
      observer.observe(elementRef?.current);
    }

    return () => {
      if (elementRef?.current) {
        observer.unobserve(elementRef?.current);
      }
    };
  }, [elementRef, options]);
  return isIntersecting;
};
